import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store/rootReducer';

import { Button as AntButton, Modal, Select } from 'antd';

const { Option } = Select;

interface IProps {
  inputCounselVisible: boolean;
  cancelInputCounsel: () => void;
  onSubmitCounsel?: () => void;
  counselTitle: string;
  setCounselTitle: (title: string) => void;
  counselContent: string;
  setCounselContent: (title: string) => void;
  counselType: string;
  setCounselType: (type: string) => void;
  isDisabled?: boolean;
}

const InputCounselModal: FC<IProps> = ({
  inputCounselVisible,
  cancelInputCounsel,
  onSubmitCounsel = () => {},
  counselTitle,
  setCounselTitle,
  counselContent,
  setCounselContent,
  counselType,
  setCounselType,
  isDisabled = false,
}) => {
  const { t } = useTranslation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // MB0004 = 상담 유형
  const MB0004 = commonCodes.find(
    (item: any) => item.commonCode === 'MB0004',
  )?.detailCode;

  return (
    <Modal
      title={isDisabled ? t('student.student.tab3') : t('campus.staff.title4')}
      visible={inputCounselVisible}
      onCancel={cancelInputCounsel}
      footer={
        isDisabled
          ? [
              <div className='comm-btn__area justify-content-center'>
                <AntButton key="cancel" className='btn-basic gray' onClick={cancelInputCounsel}>
                  {t('common.button.close')}
                </AntButton>
              </div>
            ]
          : [
              <div className='comm-btn__area justify-content-center'>
                <AntButton
                  key="submit"
                  className='btn-basic pink'
                  onClick={onSubmitCounsel}
                  disabled={isDisabled}
                >
                  {t('common.button.save')}
                </AntButton>
                <AntButton key="cancel" className='btn-basic gray' onClick={cancelInputCounsel}>
                  {t('common.button.cancel')}
                </AntButton>
              </div>
            ]
      }
    >
      <div className="flex">
        <input
          type="text"
          className="form-control input-text mr-1"
          placeholder={t('common.column.title')}
          value={counselTitle}
          onChange={(e) => setCounselTitle(e.target.value)}
          disabled={isDisabled}
        />
        <div className="w-210p">
          <Select
            className="w-100"
            value={counselType}
            onChange={(value) => setCounselType(value)}
            disabled={isDisabled}
          >
            {MB0004?.map((item: any) => {
              return (
                <Option key={item.detailCode} value={item.detailCode}>
                  {item.korName}
                </Option>
              );
            })}
          </Select>
        </div>
      </div>
      <textarea
        className="mt-1"
        placeholder={t('campus.staff.column10')}
        rows={10}
        value={counselContent}
        onChange={(e) => setCounselContent(e.target.value)}
        disabled={isDisabled}
      />
    </Modal>
  );
};

export default InputCounselModal;
